import { P } from 'ia-react-core';
import styled from 'styled-components';
import { ReactComponent as DocumentsIcon } from '../../../../assets/documents.svg';

export const StyledDocumentsIcon = styled(DocumentsIcon)`
  width: 60px;
  margin-bottom: 20px;
`;

export const StyledP = styled(P)`
  font-weight: bold;
  margin-bottom: 15px;
`;

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const StyledListItem = styled.li`
  &:before{
    content:"•";
    padding-right: 8px;
    font-size: 14px;
  }
  display: flex;
  flex-wrap: wrap;
`;

export const StyledListItemText = styled(P)`
  flex: 1 0 25%;
`;
